import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import {HashLink as LinkH } from 'react-router-hash-link';

/* ${({scrollNav}) => (scrollNav ? 'rgba(197, 214, 226, 0.8)' : 'transparent')}; */

export const Nav = styled.nav`
    background: transparent;
    height: 80px;
    display: flex;
    margin-top: -80px;
    align-items: center;
    font-size: 1rem;
    max-width: 100%;
    position: sticky;
    justify-content: space-between;
    top: 0;
    z-index: 10;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }

    @media screen and (max-width: ${({ theme }) => theme.tablet}) {
        background: #fff;
    }
`;

export const NavbarContainer = styled.div`
    position: relative;
    display: flex;
    height: 80px;
    z-index: 1;
    padding: 0 24px;
    max-width: 1100px;
    margin-right: 1rem;
`;

export const NavLogo = styled(LinkR)`
    justify-self: flex-start;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: 4rem;
    text-decoration: none;
`;

export const Logo = styled.h1`
    letter-spacing: 1rem;
    font-size: 3rem;
    display: flex;
    color: white;
    padding-top: 2rem;
    margin-top: 0.1rem;
`;

export const MobileIcon = styled.div`
    display: none;
    
    @media screen and (max-width: ${({ theme }) => theme.tablet}) {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.8rem;
        cursor: pointer;
    }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;

    @media screen and (max-width: ${({ theme }) => theme.tablet}) {
        display: none;
    }
`;

export const NavItem = styled.li`
`;

export const NavLinks = styled(LinkH)`
    color: #fff; 
    display: ${({scrollNav}) => (scrollNav ? 'none' : 'flex')};
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    /* text-shadow: 1px 3px 9px #000; */

    &.active {
        border-bottom: 3px solid ${({theme}) => theme.primaryLight};
    }
    &:hover {
        transition: all 0.2s ease-in-out;
        color: ${({ theme }) => theme.textDark};
    }
`;

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;
    margin-left: 3rem;

    @media screen and (max-widht: 1150px) {
        margin-left: 0rem;
    }

    @media screen and (max-width: ${({ theme }) => theme.tablet}) {
        display: none;
    }
`;

export const NavBtnLink = styled(LinkR)`
    border-radius: 50px;
    background: transparent;
    white-space: nowrap;
    padding: 10px 22px;
    color: #fff;
    font-size: 16px;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    display: ${({scrollNav}) => (scrollNav ? 'none' : 'flex')};

    &:hover {
        transition: all 0.2s ease-in-out;
        color: ${({ theme }) => theme.textDark};
    }
`;